import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendPharmacyDriverArrivedCall = async ({ callerId, phoneNumber }: { callerId: string; phoneNumber: string }) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      phoneNumber,
    },
    mutation: graphql(`
      mutation SendPharmacyDriverArrivedCall($callerId: String!, $phoneNumber: String) {
        sendPharmacyDriverArrivedCall(callerId: $callerId, phoneNumber: $phoneNumber)
      }
    `),
  });

  return response.data?.sendPharmacyDriverArrivedCall ?? '';
};
